module.exports = __webpack_public_path__ + "img/default_img.dd51661e.png";